var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoreStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0489 1.54508C17.3483 0.623774 18.6517 0.62377 18.9511 1.54508L22.127 11.3197C22.3948 12.1437 23.1627 12.7016 24.0291 12.7016H34.3067C35.2754 12.7016 35.6782 13.9412 34.8945 14.5106L26.5798 20.5517C25.8788 21.061 25.5855 21.9637 25.8532 22.7877L29.0292 32.5623C29.3285 33.4836 28.274 34.2497 27.4903 33.6803L19.1756 27.6393C18.4746 27.13 17.5254 27.13 16.8244 27.6393L8.50968 33.6803C7.72597 34.2497 6.67148 33.4836 6.97084 32.5623L10.1468 22.7877C10.4145 21.9637 10.1212 21.061 9.42025 20.5517L1.10549 14.5106C0.321782 13.9412 0.724556 12.7016 1.69328 12.7016H11.9709C12.8373 12.7016 13.6052 12.1437 13.873 11.3197L17.0489 1.54508Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreStar);
export default __webpack_public_path__ + "static/media/score-star.a280bdcd64b4df6ace42ce0c25bb7edd.svg";
export { ForwardRef as ReactComponent };